import HeaderLogo from '../../components/HeaderLogo';

export default function SpaceProject() {
  return <HeaderLogo shortName="project" />;
}
